module.exports = "<div class=\"area-nav-tabs\" role=\"navigation\" *ngIf=\"tabs != nullValue\">\r\n    <ul class=\"nav nav-tabs\">\r\n        <li *ngFor=\"let tab of tabs\" [class.active]=\"tab == activeTab\">\r\n            <a (click)=\"setActiveTab(tab)\" class=\"pills-button tab-store-details\">\r\n                {{tab.title}}\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/components/tab-strip.template.html
// module id = 395
// module chunks = 10